import type { TierHero } from '../types';
import { tierBoundaryCutIndices } from './tierBandCounts';

/**
 * 降順 tierScore の配列について、隣接ティア境界の「中点スコア」
 * （区間 (T_lower, T_upper) 内なら同じ分割になる閾値の代表値）
 */
export function tierBoundaryMidScores(sortedDesc: TierHero[]): number[] {
  const n = sortedDesc.length;
  if (n < 2) return [];
  const mids: number[] = [];
  for (const k of tierBoundaryCutIndices(n)) {
    if (k > 0 && k < n) {
      const up = sortedDesc[k - 1]!.tierScore;
      const lo = sortedDesc[k]!.tierScore;
      mids.push((up + lo) / 2);
    }
  }
  return mids;
}
